'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxConnect = require('redux-connect');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _reactRedux = require('react-redux');

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _statistics2 = require('selectors/statistics');

var _StatisticsProjectsList = require('../StatisticsProjectsList/StatisticsProjectsList');

var _StatisticsProjectsList2 = _interopRequireDefault(_StatisticsProjectsList);

var _StatisticsProjectsListTabs = require('components/Statistics/StatisticsProjectsListTabs/StatisticsProjectsListTabs');

var _StatisticsProjectsListTabs2 = _interopRequireDefault(_StatisticsProjectsListTabs);

var _statistics3 = require('helpers/statistics');

var _ProjectLegendLine = require('components/ProjectLegendLine/ProjectLegendLine');

var _ProjectLegendLine2 = _interopRequireDefault(_ProjectLegendLine);

var _SearchBar = require('components/SearchBar/SearchBar');

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _Pagination = require('components/Pagination/Pagination');

var _Pagination2 = _interopRequireDefault(_Pagination);

var _reactScroll = require('react-scroll');

var _reactScroll2 = _interopRequireDefault(_reactScroll);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./StatisticsProjects.scss');

var scroll = _reactScroll2.default.animateScroll;

var StatisticsProjects = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch,
        id = _ref.params.id;

    if (id) {
      return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadReport(id)).promise);
    }
  }
}, {
  promise: function promise(_ref2) {
    var dispatch = _ref2.store.dispatch;
    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadRecipients()).promise);
  }
}, {
  promise: function promise(_ref3) {
    var _ref3$store = _ref3.store,
        dispatch = _ref3$store.dispatch,
        getState = _ref3$store.getState,
        _ref3$location$query$ = _ref3.location.query.tab,
        tab = _ref3$location$query$ === undefined ? _statistics3.projectTabs.my : _ref3$location$query$;
    var activeProjectsTab = getState().report.activeProjectsTab;

    if (activeProjectsTab !== tab) {
      dispatch(statisticsActions.setProjectsTab(tab));
      var promise = null;
      if (tab === _statistics3.projectTabs.available) {
        promise = dispatch(statisticsActions.loadAvailableProjects({ useCache: true })).promise;
      } else if (tab === _statistics3.projectTabs.my) {
        promise = dispatch(statisticsActions.loadMyProjects({ useCache: true })).promise;
      }
      return (0, _asyncPromise2.default)(promise);
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  var activeProjectsTab = state.statistics.activeProjectsTab;

  var projects = [];
  var projectsCount = 0;
  var projectsLoading = false;
  var page = 1;
  if (activeProjectsTab === _statistics3.projectTabs.my) {
    var myProjectsEntities = (0, _statistics2.getMyProjects)(state);
    projects = myProjectsEntities.projects;
    projectsCount = myProjectsEntities.countAll;
    projectsLoading = state.statistics.myProjectsLoading;
    page = state.statistics.myProjectsListPage;
  } else if (activeProjectsTab === _statistics3.projectTabs.available) {
    projects = (0, _statistics2.getAvailableProjects)(state);
    projectsCount = projects.length;
    projectsLoading = state.statistics.availableProjectsLoading;
  }
  return {
    activeProjectsTab: state.statistics.activeProjectsTab,
    availableProjects: (0, _statistics2.getAvailableProjects)(state),
    page: page,
    projects: projects,
    projectsCount: projectsCount,
    projectsLoading: projectsLoading
  };
}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(StatisticsProjects, _Component);

  function StatisticsProjects() {
    (0, _classCallCheck3.default)(this, StatisticsProjects);
    return (0, _possibleConstructorReturn3.default)(this, (StatisticsProjects.__proto__ || (0, _getPrototypeOf2.default)(StatisticsProjects)).apply(this, arguments));
  }

  (0, _createClass3.default)(StatisticsProjects, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.setProjectsTab(null);
      this.filter('');
    }
  }, {
    key: 'onPageChange',
    value: function onPageChange(_ref4) {
      var page = _ref4.page;

      this.props.setProjectsListPage({ page: page });
      scroll.scrollToTop();
    }
  }, {
    key: 'selectProjectsTab',
    value: function selectProjectsTab(tab) {
      this.context.push('/statistics/project?tab=' + tab);
    }
  }, {
    key: 'filter',
    value: function filter(kw) {
      this.props.filterProjects(kw);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          projects = _props.projects,
          projectsLoading = _props.projectsLoading,
          activeProjectsTab = _props.activeProjectsTab,
          projectsCount = _props.projectsCount,
          page = _props.page;
      var t = this.context.t;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(className) },
        _react2.default.createElement(
          'div',
          { className: styles.searchLine },
          _react2.default.createElement(_SearchBar2.default, {
            className: styles.searchBar,
            inputClass: styles.searchInput,
            onChange: this.filter
          }),
          _react2.default.createElement(_ProjectLegendLine2.default, { className: styles.legendLine }),
          _react2.default.createElement(
            'div',
            { className: styles.searchHint },
            t('You can search by title, project ID')
          )
        ),
        _react2.default.createElement(_StatisticsProjectsListTabs2.default, {
          activeProjectsTab: activeProjectsTab,
          onClick: this.selectProjectsTab
        }),
        _react2.default.createElement(
          'div',
          { className: styles.list },
          _react2.default.createElement(_StatisticsProjectsList2.default, {
            projects: projects,
            projectsLoading: projectsLoading
          })
        ),
        _react2.default.createElement(_Pagination2.default, {
          className: 'text-right',
          count: projectsCount,
          limit: _statistics3.pageLimit,
          page: page,
          onChange: this.onPageChange
        })
      );
    }
  }]);
  return StatisticsProjects;
}(_react.Component), _class3.propTypes = {
  activeProjectsTab: _propTypes2.default.string,
  className: _propTypes2.default.string,
  filterProjects: _propTypes2.default.func,
  page: _propTypes2.default.number,
  projects: _propTypes2.default.array,
  projectsCount: _propTypes2.default.number,
  projectsLoading: _propTypes2.default.bool,
  setProjectsListPage: _propTypes2.default.func,
  setProjectsTab: _propTypes2.default.func
}, _class3.defaultProps = {
  projects: [],
  onClick: _noop3.default,
  tab: _statistics3.projectTabs.my
}, _class3.contextTypes = {
  push: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onPageChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onPageChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'selectProjectsTab', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'selectProjectsTab'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'filter', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'filter'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = StatisticsProjects;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/StatisticsProjects/StatisticsProjects.js
// module id = 2220
// module chunks = 1